/**
 * 약관·개인정보처리방침에 들어가는 운영자 정보 — **한 곳에서만 고친다.**
 *
 * 약관 · 개인정보처리방침 · 소개(/about) · 푸터가 이 값을 같이 쓴다. 빈 값이면
 * 화면에 「(기재 예정)」으로 나간다.
 */
export const LEGAL = {
  /** 서비스 이름. 문서 본문에서 「회사」 대신 이 이름을 쓴다. */
  service: '좋소 과수원',
  domain: 'zoxo.kr',
  /** 운영 주체(상호 또는 성명). */
  operator: '에스아이 (S.I.)',
  /** 대표자 성명. */
  representative: '공대삼촌',
  /** 사업자등록번호. */
  businessNumber: '889-15-02079',
  /** 개인정보 보호책임자 성명. */
  officer: '공대삼촌',
  /** 문의·개인정보 관련 연락처 이메일. */
  email: 'uncle@zoxo.kr',
  /** 공고일 = 시행일. 개정하면 여기와 아래 「변경 내역」을 같이 고친다. */
  effectiveDate: '2026년 9월 9일',
} as const;

export const orBlank = (v: string) => (v.trim().length > 0 ? v : '(기재 예정)');
